import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useStyles } from './styles';

export default function GlobalTeam() {
  const classes = useStyles();

  return (
    <Box bgcolor="#F1F1F1" py={9} px={16.62} className={classes.mainContainer}>
      <Container>
        <LazyLoad>
          <Box className={classes.mainBox}>
            <Typography className={classes.title}>
              <span>Global team</span> of subject experts
            </Typography>

            <Grid container spacing={2} direction="row" justifyContent="center">
              <Grid item xs={12} sm={3}>
                <Box display="grid" justifyItems="center">
                  <Image
                    src="/images/custom-services/stunning.svg"
                    alt="stunning image"
                    height={182}
                    width={182}
                    loading="lazy"
                  />

                  <Box pb={1} pt={2}>
                    <Typography style={{ color: '#424B5A' }}>
                      <b>Stunning illustrations</b>
                    </Typography>
                  </Box>

                  <Typography align="center" style={{ color: '#424B5A' }}>
                    Use the world&apos;s largest scientific illustrations set to draw attention to
                    what matters.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Box display="grid" justifyItems="center">
                  <Image
                    src="/images/custom-services/professional.svg"
                    alt="stunning image"
                    height={182}
                    width={182}
                    loading="lazy"
                  />

                  <Box pb={1} pt={2}>
                    <Typography style={{ color: '#424B5A' }}>
                      <b>Scientific accuracy</b>
                    </Typography>
                  </Box>

                  <Typography align="center" style={{ color: '#424B5A' }}>
                    Increase the credibility of your work with scientific illustrations curated by
                    scientists.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Box display="grid" justifyItems="center">
                  <Image
                    src="/images/custom-services/express.svg"
                    alt="stunning image"
                    height={182}
                    width={182}
                    loading="lazy"
                  />

                  <Box pb={1} pt={2}>
                    <Typography style={{ color: '#424B5A' }}>
                      <b>Professional publications</b>
                    </Typography>
                  </Box>

                  <Typography align="center" style={{ color: '#424B5A' }}>
                    Get the permission and full copyrights to publish your ideas with amazing
                    science figures
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Box display="grid" justifyItems="center">
                  <Image
                    src="/images/custom-services/accuracy.svg"
                    alt="stunning image"
                    height={182}
                    width={182}
                    loading="lazy"
                  />

                  <Box pb={1} pt={2}>
                    <Typography style={{ color: '#424B5A' }}>
                      <b>Express method</b>
                    </Typography>
                  </Box>

                  <Typography align="center" style={{ color: '#424B5A' }}>
                    Save time during your publication process with fair deadlines and fast
                    deliveries.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </LazyLoad>
      </Container>
    </Box>
  );
}
